import { apiClient } from "@/http";
import { apiRoutes } from "./apiRoutes";
import type { ChannelVideoResolution } from "./channelVideoResolution";

// 채널 이름의 좌우 방향에서 파생한 팔 구성이다. backend entity/dataset::ArmLayout 과 같다.
// 미판정은 이 유니온 값이 아니라 null 로 표현한다. 판정 규칙:
//   - 좌우가 모두 있으면 bimanual
//   - 채널은 있지만 어느 이름에도 방향이 없으면 single_arm
//   - 한쪽 방향만 있으면 양팔의 결손인지 단완인지 구분할 수 없어 미판정(null)
export type ArmLayout = "single_arm" | "bimanual";

// 한 채널(topic 하위 디렉터리 또는 flat parquet 컬럼)의 구조 요약이다.
// dim/arm_side/kind 같은 메타는 hatchery-data 명명규칙(SoT)이 계산한 값을 그대로 전달한다.
export type DatasetStructureChannel = {
  topic: string;
  name: string;
  episode_count: number;
  media: string;
  dim: number | null;
  dtype: string | null;
  group: string | null;
  arm_side: "left" | "right" | null;
  // `[3, H, W]`. 해상도가 하나인 카메라만 값을 가진다. 그 외(비카메라·혼재·모름)는 null.
  camera_shape: number[] | null;
  // 영상 채널의 해상도 투영이다. 영상 채널이 아니면 null 이다.
  // 상태의 의미는 `channelVideoResolution` 경계가 정한다.
  video_resolution: ChannelVideoResolution | null;
};

// 공용 Dataset 채널 구조다(topic→채널·dim·arm_layout). 학습 제출은 이 값에서 mux override
// 후보를 고른다. 상세 개요의 채널 구조 카드도 이 값을 표시한다.
export type DatasetStructure = {
  dataset_uuid: string;
  episode_count: number;
  arm_layout: ArmLayout | null;
  channels: DatasetStructureChannel[];
};

export async function getDatasetStructure(datasetUuid: string): Promise<DatasetStructure> {
  const response = await apiClient.get<DatasetStructure>(apiRoutes.dataset.structure(datasetUuid));
  return response.data;
}
